import React from "react"
import { graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import styled from "styled-components"

import PublicationCustom from "../../layouts/PublicationCustom"
import Spacer from "../../components/Spacer"
import Seo from "../../components/Seo"
import MobilityStudyCharts from "../../components/publications/MobilityStudyCharts"

import { media } from "../../styles"

const IllustrationImage = styled.div`
  margin: -60px auto 0;
  width: 270px;

  @media ${media.sm} {
    margin: -120px auto 0;
  }

  @media ${media.md} {
    margin: 0 auto;
  }

  @media ${media.lg} {
    bottom: 85px;
    left: 85px;
    margin: 0;
    position: absolute;
    width: 360px;
  }

  @media ${media.xl} {
    bottom: 60px;
    left: 105px;
    width: 450px;
  }

  @media ${media.xxl} {
    bottom: -50px;
    left: 120px;
    width: 504px;
  }
`

export const pageQuery = graphql`
  query MobilityPageQuery($language: String, $originalPath: String) {
    contentfulPageMetadata(
      pagePath: { eq: $originalPath }
      node_locale: { eq: $language }
    ) {
      ...PageMetadata
    }
    contentfulPublication(
      slug: { eq: "mobility-whitepaper" }
      node_locale: { eq: $language }
    ) {
      ...PublicationQuery
    }
    relatedPublications: allContentfulPublication(
      filter: {
        slug: { ne: "mobility-whitepaper" }
        node_locale: { eq: $language }
        pageGeneration: { regex: "/custom|simple/" }
      }
      sort: { date: DESC }
      limit: 3
    ) {
      nodes {
        ...PublicationRelatedQuery
      }
    }
  }
`

const WhitepaperMobilityPage = ({ data }) => {
  const pageMetadata = data.contentfulPageMetadata
  const publication = data.contentfulPublication
  const relatedPublications = data.relatedPublications.nodes

  const socialShareImages = {}
  if (publication.socialShareImageOpengraph) {
    socialShareImages.socialShareImageOpengraph = `${publication.socialShareImageOpengraph.gatsbyImageData.images.fallback.src}`
  }
  if (publication.socialShareImageTwitter) {
    socialShareImages.socialShareImageTwitter = `${publication.socialShareImageTwitter.gatsbyImageData.images.fallback.src}`
  }

  return (
    <PublicationCustom
      publication={publication}
      relatedPublications={relatedPublications}
      heroIllustration={
        publication.coverImage ? (
          <IllustrationImage>
            <GatsbyImage
              alt={publication.title}
              image={publication.coverImage.gatsbyImageData}
            />
          </IllustrationImage>
        ) : null
      }
    >
      <Seo {...pageMetadata} {...socialShareImages} lang="en" />
      <Spacer height={80} lg={0} />
      <MobilityStudyCharts />
    </PublicationCustom>
  )
}

export default WhitepaperMobilityPage
